import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import usePopup from "../../hooks/usePopup";
import { useMutation, useQuery } from "react-query";
import { useEffect } from "react";
import { Button, CircularProgress, Divider, Paper, Typography } from "@mui/material";
import { ArrowBack, Close, Save } from "@mui/icons-material";
import { CustomFormField } from "../../utilis/component/CustomFormElement";
import { MasterDataListType, formDataType } from "./types";
import {getAllTag, saveMasterData} from "./Service";
import { clinicId } from "../../constants";
import { FormOnChangeEventType } from "../../EMR/types";
import useAuthentication from "@hooks/useAuthentication";


function AddOrEditPage() {
 const pageTitle="Expense Manager"
  const navigate = useNavigate();
  const {user} = useAuthentication()
  const { control, handleSubmit, reset,setValue } = useForm<formDataType>();
  const {
    state: { data=null },
  } = useLocation()  as { state: { data: MasterDataListType } };
  const { showSnackbar } = usePopup();
    const handleGoBack = () => {
    navigate(-1);
  };

const { data: tagList } = useQuery(
  ["getAllTag"],
  () => getAllTag()
)

  const { mutate: submitExpense, isLoading } = useMutation(saveMasterData, {
    onSuccess: (result) => {
      if (result.responseIndicator == "success") {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "success",
          duration: 3000,
        });
        handleGoBack()
      } else {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "warning",
          duration: 3000,
        });
      }
    },
    onError: (e: any) => {
      showSnackbar({
        message: e?.response?.data?.responseMessage || "Something went wrong !",
        open: true,
        variant: "error",
        duration: 3000,
      });
    },
  });
  const onSubmit = (value: formDataType) => {
    submitExpense([{
      clinicId: clinicId,
      createdById: Number(user?.userId), 
      expenseReportDate: data?.expenseReportDate || value.Date,
      categoryId:data?.categoryId || null, 
      tagId: value?.particulars?.tagId as number,
      amount: Number(value.Amount),
      item: value.description as string,
      id: data?.id || null,
    }]);
  };


  const onChange = ( e: FormOnChangeEventType) => {
    const type =e?.target?.value?.catName
    setValue("AccountType", type);
  }



  useEffect(() => {
    if (data) {
      reset({
        Date: data?.expenseReportDate || "",
        AccountType: data?.catName || "",
        particulars: {
          tagId: data?.tagId || 0,
          tagName: data?.tagName|| "",
        },
        Amount: data?.amount || 0,
        description: data?.item || ""
      });
    }
  }, [data]);

  return (
    <div className="p-3">
      <form onSubmit={handleSubmit(onSubmit)}>
        <Paper>
          <div className="flex justify-between items-center p-2">
            <div>
              <Typography variant="h6" className="p-3">
                Add {pageTitle}
              </Typography>
            </div>
            <div className="flex gap-2">
              <Button
                variant="outlined"
                startIcon={<ArrowBack/>}
                onClick={handleGoBack}
              >
                back
              </Button>
              <Button
                disabled={isLoading}
                color="error"
                onClick={()=>reset({
                  Date: "",
                  AccountType: "",
                  particulars: null,
                  Amount: 0,
                  description: ""
                })}
                startIcon={<Close/>}
              >
                reset
              </Button>
              <Button
                disabled={isLoading}
                type="submit"
                color="success"
                startIcon={
                  isLoading ? (
                    <CircularProgress size={20} color="success" />
                  ) : (
                    <Save/>
                  )
                }
              >
                {data ? "Update" : "Save"}
              </Button>
            </div>
          </div>
          <Divider />
          <div className="p-3 grid grid-cols-4 gap-3">
            <CustomFormField
              control={control}
              name="Date"
              element="datepicker"
              fieldProps={{ label: "enter Date " }}
              rules={{ required: "Date is required" }}
            />
            <CustomFormField
              control={control}
              name="particulars"
              element="autocomplete"
              fieldProps={{ label: "particulars " }}
              rules={{ required: "particulars required",onChange }}
              options={tagList?.response??[]}
              autocompleteProps={{
                isOptionEqualToValue: (option: any, value: any) => option.tagId === value.tagId,
                getOptionLabel: (option: any) => option.tagName ||""
              }}
            />
            <CustomFormField
              control={control}
              name="AccountType"
              element="input"
              fieldProps={{ label: "AccountType",disabled:true }}
              rules={{ required: "AccountType is required" }}
            />
       
              <CustomFormField
                control={control}
                name="Amount"
                element="input"
                fieldProps={{ label: "Enter Amount " }}
                rules={{ required: "Amount required" }}
              />
              <CustomFormField
                control={control}
                name="description"
                element="input"
                fieldProps={{ label: "Enter Description" }}
                rules={{ required: false }}
              />
          </div>
        </Paper>
      </form>
    </div>
  );
}
export default AddOrEditPage
